module.exports = __webpack_public_path__ + "static/media/helpdesk.371731f4.svg";